define('Components/SeparatorWidget/js/SeparatorWidget',['hooks',
        'Components/SeparatorWidget/js/views/SeparatorWidgetInstanceView',
        'Components/SeparatorWidget/js/models/SeparatorWidgetInstanceModel',
    ],
    function (hooks, SeparatorWidgetInstanceView, SeparatorWidgetInstanceModel) {

        return function () {
            hooks.registerWidgetInstance('SeparatorWidget', SeparatorWidgetInstanceView, SeparatorWidgetInstanceModel);
        }

    });
